module.exports = __webpack_public_path__ + "static/media/mainimg-02.4561bae7.png";